/**
 * Admin layout with sidebar
 */

import { Outlet } from 'react-router-dom'
import { AdminSidebar } from './components/AdminSidebar'

export function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-gut8-bg">
      <AdminSidebar />
      <main className="flex-1 p-8 overflow-auto bg-gut8-bg text-gut8-anthracite">
        <Outlet />
      </main>
    </div>
  )
}
